import { Box, Typography, useTheme } from '@mui/material';
import PieDoughnutChart from 'common/components/charts/pie-doughnut-chart';
import React from 'react';
interface IPieChartProps {
    title: string;
    imageUrl?: string;
    colors?: [string, string];
    data: { value: number; name: string }[];
}
const PieChart: React.FC<IPieChartProps> = ({
    title,
    imageUrl,
    colors,
    data,
}) => {
    const theme = useTheme();
    const chartColors = colors ?? [theme.palette.primary.main, '#FF7916'];
    return (
        <Box>
            <Typography
                sx={{
                    fontWeight: 700,
                    fontSize: '28px',
                    textAlign: 'left',
                    lineHeight: '33.89px',
                }}
            >
                {title}
            </Typography>
            <PieDoughnutChart
                option={{
                    color: chartColors,
                    title: '',
                    tooltip: {
                        trigger: 'item',
                    },
                    legend: {
                        padding: [20, 0, 0, 20],
                        bottom: '0',
                        left: 'center',
                        icon: 'circle',
                        textStyle: {
                            fontSize: 14,
                            color: '#000000B2',
                        },
                    },
                    series: [
                        {
                            name: title,
                            type: 'pie',
                            radius: ['55%', '75%'],
                            avoidLabelOverlap: false,
                            label: {
                                color: '#000000B2',
                                fontSize: '24',
                                position: 'center',
                                fontWeight: 'bold',
                                show: imageUrl ? false : true,
                                formatter: () => {
                                    return ``;
                                },
                            },
                            labelLine: {
                                show: false,
                            },

                            data: data,
                        },
                    ],
                    ...(imageUrl && {
                        graphic: {
                            type: 'image',
                            left: 'center',
                            top: 'center',
                            z: 100,
                            style: {
                                image: imageUrl,
                                width: 60,
                                height: 60,
                            },
                        },
                    }),
                }}
            />
        </Box>
    );
};

export default PieChart;
